// eslint-disable-next-line no-shadow
export enum StatusResetPassword {
  pending = 0,
  read = 1,
  used = 2
}
